﻿/* eslint-disable no-console */
import { Widget } from "blue-widgets";

class SubscribeBlock extends Widget {
    constructor(el) {
        super(el);

        if (!this.el) return;

        this.subscribeBlockForm = this.el.querySelector(".subscribe__form");

        if (!this.subscribeBlockForm) return;

        this.token = this.el.querySelector("input[name=\"__RequestVerificationToken\"]")?.value;
        this.emailInput = this.subscribeBlockForm.querySelector("#subscribe-block-input");
        this.subscribeButton = this.subscribeBlockForm.querySelector(".button--primary");
        this.receiverEmailAddress = this.el.getAttribute("data-receiver-email");
        this.subscribeApiUrl = this.el.getAttribute("data-subscribe-api-url");
        this.notificationText = this.el.getAttribute("data-notification-text");
        this.subscribeContainer = this.el.querySelector(".subscribe");

        this.subscribeButton.addEventListener("click", this.handleClick);
    }

    handleClick = async () => {
        this.subscribeButton.setAttribute("disabled", "");
        this.clearNotification();

        await fetch(this.subscribeApiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "RequestVerificationToken": this.token
            },
            body: JSON.stringify({
                subscriber: this.emailInput.value,
                receiverEmailAddress: this.receiverEmailAddress
            })
        })
            .then((response) => {
                if (response.ok) {
                    this.subscribeButton.removeAttribute("disabled", "");
                    this.emailInput.value = "";
                    this.displayNotification(this.notificationText);
                } else {
                    this.subscribeButton.removeAttribute("disabled", "");
                    console.error("Error sending POST request. Status:", response.status);
                }
            })
            .catch((error) => {
                this.subscribeButton.removeAttribute("disabled", "");
                console.error("Error sending POST request:", error);
            });
    };

    clearNotification = () => {
        const notificationDiv = this.el.querySelector(".subscribe__notification");

        if (!notificationDiv) return;

        notificationDiv.remove();
    };

    displayNotification = (notificationText) => {
        const subscribeNotificationDiv = this.createNotificationDiv(notificationText);
        this.subscribeContainer.insertBefore(subscribeNotificationDiv, this.subscribeContainer.firstChild);
    };

    createNotificationDiv = (notificationText) => {
        const subscribeNotificationDiv = document.createElement("div");
        subscribeNotificationDiv.className = "subscribe__notification";

        // Create the icon element
        const iconElement = document.createElement("i");
        iconElement.className = "icon icon-info";
        iconElement.setAttribute("aria-hidden", "true");

        // Create the paragraph element
        const paragraphElement = document.createElement("p");
        paragraphElement.className = "body2";
        paragraphElement.innerHTML = notificationText;

        // Append the icon and paragraph elements to the main div
        subscribeNotificationDiv.appendChild(iconElement);
        subscribeNotificationDiv.appendChild(paragraphElement);

        return subscribeNotificationDiv;
    };
}

export default SubscribeBlock;